import store from '../../utils/localStorageFallback';
import googleTagSetAudienceType from '../../utils/googleTagSetAudienceType';

const hideSections = () => {
  const storeVersion = store('version');
  const allSections = document.querySelectorAll('.investors, .investor, .adviser');
  let sectionsToHide;

  for (let i = 0; i < allSections.length; i += 1) {
    allSections[i].classList.add('u-hidden');
  }

  if (storeVersion === 'investor') {
    sectionsToHide = document.querySelectorAll(`.${storeVersion}, .investors`);
  } else {
    sectionsToHide = document.getElementsByClassName(`${storeVersion}`);
  }

  for (let i = 0; i < sectionsToHide.length; i += 1) {
    sectionsToHide[i].classList.remove('u-hidden');
  }
};

const forceRoleRedirect = () => {
  const user = store('version');

  if (document.body.classList.contains('adviser') || document.body.classList.contains('investor')) {
    // in a restricted page/ post / product.
    if (!document.body.classList.contains(user)) {
      // redirect to home if now allowed.
      document.location.href = '/';
    }
  }
};

const clientPlanningReload = () => {
  if (document.body.classList.contains('page-template-client-planning')) {
    document.location.reload();
  }
};

const resourceCentreReload = () => {
  const path = document.location.pathname;

  if (
    path.includes('/resources/') &&
    document.body.classList.contains('page-template-resource-centre')
  ) {
    document.location.href = '/resources/';
  }
};

const modal = document.querySelector('.modal');
const roleSelect = document.getElementsByClassName('modal-content-role-select')[0];
let storeVersion;

const toggleModal = () => {
  const currentState = modal.style.display;
  // If modal is visible, hide it. Else, display it.
  if (currentState === 'none') {
    modal.style.display = 'block';
  } else {
    modal.style.display = 'none';
  }
};

const docReady = (fn) => {
  // see if DOM is already available
  if (document.readyState === 'complete' || document.readyState === 'interactive') {
    // call on next available tick
    setTimeout(fn, 1);
  } else {
    document.addEventListener('DOMContentLoaded', fn);
  }
};

// eslint-disable-next-line no-undef,camelcase
const investmentsWebsiteURL = deepsea_investments.investments_website_link;
// eslint-disable-next-line no-undef,camelcase
const institutionalWebsiteURL = deepsea_investments.institutional_website_link;
const topNavLinks = document.querySelectorAll('.top-nav--modal a');
const topNavLinksClass = document.querySelectorAll('.top-nav--modal');
const linkTextElement = document.getElementById('linkText');

docReady(() => {
  if (topNavLinks.length > 0) {
    storeVersion = store('version');

    Array.from(topNavLinks).forEach((link) => {
      if (link.href.includes('/#content-investor')) {
        link.classList.add('investor');
        link.classList.remove('adviser');
      }
      if (link.href.includes('/#content-adviser')) {
        link.classList.add('adviser');
        link.classList.remove('investor');
      }
    });

    if (storeVersion === 'investor') {
      linkTextElement.textContent = ' / Individual Investor';
      Array.from(topNavLinksClass).forEach((link) => {
        link.classList.add('Investor');
      });
    }

    if (storeVersion === 'adviser') {
      linkTextElement.textContent = ' / Financial Adviser';
      Array.from(topNavLinksClass).forEach((link) => {
        link.classList.add('Adviser');
      });
    }

    const activeButtons = document.querySelectorAll(
      `.top-nav--modal a[href="#content-${storeVersion}"]`,
    );
    Array.from(activeButtons).forEach((btn) => {
      const listItem = btn.parentNode;
      listItem.classList.add('active');
    });

    Array.from(topNavLinks).forEach((link) => {
      const unidentified = document.body.classList.contains('unidentified');
      if (unidentified && storeVersion === null) {
        linkTextElement.style.display = 'none';
      }

      link.addEventListener('click', (e) => {
        const { target } = e;
        let version;

        if (target.hash === '#content-investor') {
          version = 'investor';
          linkTextElement.textContent = ' / Individual Investor';
          e.preventDefault();
        }

        if (target.hash === '#content-adviser') {
          version = 'adviser';
          linkTextElement.textContent = ' / Financial Adviser';
          e.preventDefault();
        }

        if (unidentified) {
          modal.style.display = 'none';
          window.location.href = `${window.location.origin}`;
        }

        if (
          target.getAttribute('href').includes('ii-rebrand.local.octps.co') ||
          target.getAttribute('href').includes('ii-rebrand.develop.octps.co') ||
          target.getAttribute('href').includes('ii-rebrand.staging.octps.co') ||
          target.getAttribute('href').includes('institutional.octopusinvestments')
        ) {
          version = 'institutional-investor';
          linkTextElement.textContent = ' / Institutional Investor';
          e.preventDefault();
        }

        if (version === 'investor') {
          linkTextElement.textContent = ' / Individual Investor';
          Array.from(topNavLinksClass).forEach((linkNav) => {
            linkNav.classList.add('Investor');
            linkNav.classList.remove('Adviser');
          });
        }

        if (version === 'adviser') {
          linkTextElement.textContent = ' / Financial Adviser';
          Array.from(topNavLinksClass).forEach((linkNav) => {
            linkNav.classList.add('Adviser');
            linkNav.classList.remove('Investor');
          });
        }

        const allButtons = document.querySelectorAll(`.top-nav--modal a[href="${target.hash}"]`);
        Array.from(allButtons).forEach((btn) => {
          const listItem = btn.parentNode;
          listItem.classList.add('active');
        });

        storeVersion = store('version');

        if (storeVersion === version) {
          return false;
        }

        if (store(`${version}-confirmed`)) {
          if (
            version === 'institutional-investor' &&
            !window.location.href.includes(institutionalWebsiteURL)
          ) {
            // eslint-disable-next-line no-undef,camelcase
            window.location.href = `${institutionalWebsiteURL}${target.hash}`;
            return false;
          }

          if (
            version !== 'institutional-investor' &&
            window.location.href.includes(institutionalWebsiteURL)
          ) {
            // eslint-disable-next-line no-undef,camelcase
            window.location.href = `${investmentsWebsiteURL}#content-${version}`;
            return false;
          }

          store(`${version}-confirmed`, 'true');

          if (store('version') !== version) {
            document.dispatchEvent(new CustomEvent('audienceTypeChange', { detail: version }));
          }

          store('version', version);
          googleTagSetAudienceType(version);

          hideSections();
          forceRoleRedirect();
          resourceCentreReload();
          clientPlanningReload();

          return false;
        }

        if (
          version === 'investor' ||
          version === 'adviser' ||
          version === 'institutional-investor'
        ) {
          toggleModal();
        }

        if (version === 'adviser') {
          roleSelect.style.display = 'block';
          roleSelect.style.opacity = null;
          roleSelect.style.visibility = null;
        }

        const confirmScreen = document.getElementsByClassName(`${version}-confirm`)[0];
        const confirmButton = document.getElementsByClassName(`${version}-confirm-button`);

        if (version !== 'adviser') {
          roleSelect.style.display = 'none';
          if (confirmScreen) confirmScreen.style.display = 'block';
        }

        Array.from(confirmButton).forEach((button) => {
          button.addEventListener('click', () => {
            store(`${version}-confirmed`, 'true');

            if (
              version === 'institutional-investor' &&
              !window.location.href.includes(institutionalWebsiteURL)
            ) {
              // eslint-disable-next-line no-undef,camelcase
              window.location.href = `${institutionalWebsiteURL}${target.hash}`;
              return false;
            }

            if (
              version !== 'institutional-investor' &&
              window.location.href.includes(institutionalWebsiteURL)
            ) {
              // eslint-disable-next-line no-undef,camelcase
              window.location.href = `${investmentsWebsiteURL}#content-${version}`;
              return false;
            }

            store('version', version);
            googleTagSetAudienceType(version);

            hideSections();
            forceRoleRedirect();
            resourceCentreReload();
            clientPlanningReload();

            modal.style.display = 'none';
            confirmScreen.style.display = 'none';

            return false;
          });
        });

        return false;
      });
    });
  }
});
